import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, mediaUrl, savedBookings, type Stay } from "../api.ts";
import { useAuth } from "../auth.tsx";
import { money } from "../format.ts";
import { pick, useI18n } from "../i18n.tsx";
import { AuthForm } from "../ui/AuthForm.tsx";

export function AccountPage() {
  const { t, locale } = useI18n();
  const { me, signOut } = useAuth();
  const [stays, setStays] = useState<Stay[] | null>(null);
  useEffect(() => { if (me) api<Stay[]>("/account/bookings").then(setStays).catch(() => setStays([])); }, [me]);

  if (me === undefined) return <div className="wrap section"><div className="skel" aria-hidden="true" /></div>;

  if (me === null) {
    const local = savedBookings();
    return (
      <div className="wrap section">
        <div className="section-head"><h1 className="h1">{t("acc.title")}</h1></div>
        <div className="stack"><AuthForm />
          {local.length > 0 && (
            <section>
              <h2 className="h2">{t("acc.device")}</h2>
              <p className="muted small">{t("acc.deviceHint")}</p>
              {local.map((s) => <Link key={s.id} className="kv" to={`/b/${s.id}#${s.token}`}><span className="num">{s.code}</span><span aria-hidden="true">→</span></Link>)}
            </section>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="wrap section">
      <div className="section-head"><div><span className="eyebrow">{t("acc.hello")}</span><h1 className="h1">{me.user.name}</h1></div><button className="link small" onClick={() => void signOut()}>{t("acc.signout")}</button></div>
      <h2 className="h2" style={{ marginBlockEnd: 16 }}>{t("acc.stays")}</h2>
      {stays?.length === 0 && <div className="note"><p>{t("acc.none")}</p><Link className="link" to="/">{t("acc.browse")}</Link></div>}
      <ul className="stays">
        {stays?.map((s) => (
          <li key={s.id}>
            <Link to={`/stays/${s.id}`} className="stay">
              <span className="stay-img">{s.coverKey && <img src={mediaUrl(s.coverKey)} alt="" loading="lazy" />}</span>
              <span className="stay-body">
                <b>{s.listingTitle ? pick(s.listingTitle, locale) : s.code}</b>
                <span className="muted small num" dir="ltr">{s.checkIn} → {s.checkOut}</span>
                <span className="small">{t(`status.${s.status}`)}</span>
              </span>
              <span className="num stay-price">{money(s.totalMinor, s.currency, locale)}</span>
            </Link>
          </li>
        ))}
      </ul>
      <p style={{ marginBlockStart: 32 }}><Link className="link small" to="/host">{t("acc.owner")}</Link></p>
    </div>
  );
}
